/**
 * Coup de pouce — Attendu 1097 « addition et soustraction de fractions de
 * dénominateurs quelconques mais simples » (automatisme 4e, l. 652).
 * QUATRE pages STATIQUES, une par cas, partagées par les trois generator_keys :
 * trois pages de la fiche 1054 (importées, mêmes dessins, mêmes sacrifiés)
 * et UNE page neuve pour le cas de 4e. La page « Un entier » de 1054 saute
 * (plafond de quatre pages du sheet ; l'entier n'est plus dans la flash).
 *
 * La page neuve, « Un nombre des deux tables » : le même dessin que « Aucun
 * lien » (deux conversions à flèches), mais le commun n'est pas le produit
 * des dénominateurs : 5/6 + 3/4, 12 est dans la table de 6 (× 2) et dans la
 * table de 4 (× 3). Résultat en gros « 5/6 + 3/4 = 10/12 + 9/12 = 19/12 »,
 * une ligne du geste en langue d'élève : « 12 est dans la table de 6 et
 * dans la table de 4. »
 *
 * SACRIFIÉS : les quatre de 1054 (importés) et 5/6 avec 3/4 (gen_1097,
 * SACRIFIE, auto-testé par gen1097.self.test.js).
 */
import {
    svg, frac, op, conversion, ligneGeste, BASE,
    SVG_MEME_DEN, SVG_MULTIPLE, SVG_AUCUN_LIEN,
} from './1054';

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';

const SVG_DEUX_TABLES = svg(
    '5 sur 6 égale 10 sur 12, avec les flèches fois 2 en haut et en bas. 3 sur 4 égale 9 sur 12, avec les flèches fois 3. 5 sur 6 plus 3 sur 4 égale 10 sur 12 plus 9 sur 12 égale 19 sur 12. 12 est dans la table de 6 et dans la table de 4.',
    `<!-- 1. les deux conversions, flèches × 2 et × 3, vers le même 12 -->
  ${conversion(80, 96, 5, 6, 10, 12, 2, BLEU)}
  ${conversion(240, 96, 3, 4, 9, 12, 3, ORANGE)}

  <!-- 2. le résultat -->
  ${frac(66, 204, 5, 6, BLEU, 15, 11)}
  ${op(92, 209, '+')}
  ${frac(118, 204, 3, 4, ORANGE, 15, 11)}
  ${op(144, 209, '=')}
  ${frac(172, 204, 10, 12, BLEU, 15, 12)}
  ${op(200, 209, '+')}
  ${frac(228, 204, 9, 12, ORANGE, 15, 12)}
  ${op(256, 209, '=')}
  ${frac(284, 204, 19, 12, ENCRE, 15, 12)}

  <!-- 3. le geste -->
  ${ligneGeste(252, [{ t: '12 est dans la table de ' }, { t: '6', c: BLEU }, { t: ' et dans la table de ' }, { t: '4', c: ORANGE }, { t: '.' }])}`,
    276,
);

const AIDE = {
    pages: [
        { titre: 'Même dénominateur', court: BASE, svg: SVG_MEME_DEN },
        { titre: 'L\'un est un multiple', court: BASE, svg: SVG_MULTIPLE },
        { titre: 'Aucun lien', court: BASE, svg: SVG_AUCUN_LIEN },
        { titre: 'Un nombre des deux tables', court: BASE, svg: SVG_DEUX_TABLES },
    ],
};

const CP_1097 = {
    flash_texte_trou_saisie: AIDE,
    meme_qcm_unique: AIDE,
    meme_tableau_vf: AIDE,
};

export default CP_1097;
